import React, { ReactNode } from 'react'
import styled from 'styled-components'

const Base = styled.li<{ basic: boolean }>`
  background: ${({ theme }) => theme.palette.background.main};
  border: ${({ basic, theme }) => (basic ? `1px solid ${theme.palette.border.main}` : '0')};
  border-radius: ${({ basic }) => (basic ? '5px' : '10px')};
  box-shadow: ${({ basic }) => (basic ? 'none' : '0px 2px 6px rgba(255, 155, 191, 0.6)')};
  box-sizing: border-box;
  margin: ${({ basic }) => (basic ? '10px 0 0' : '8px 0 0')};
  width: 100%;
  &:first-child {
    margin: 0;
  }
`

const Container = styled(Base)`
  padding: 16px 16px 20px;
  @media (min-width: ${({ theme }) => theme.mediaQuery.desktop.minWidth}) {
    margin: 15px 0 0;
    padding: 25px 20px;
    width: 100%;
  }
`

const CompactContainer = styled(Base)`
  padding: 12px 12px 16px;
  @media (min-width: ${({ theme }) => theme.mediaQuery.desktop.minWidth}) {
    padding: 10px 10px 16px;
    width: calc(50% - 5px);
    &:nth-child(odd) {
      margin: 0 5px 0 0;
    }
    &:nth-child(even) {
      margin: 0 0 0 5px;
    }
  }
`

type Props = {
  basic: boolean
  children: ReactNode
  compact: boolean
}

export default function ReviewList({ basic, children, compact }: Props) {
  const Component: typeof Base = compact ? CompactContainer : Container

  return <Component basic={basic}>{children}</Component>
}
